// Types
type FhirIdentifier = {
  use?: string | null;
  system?: string | null;
  value?: string | null;
};

type FhirReference = {
  identifier?: {
    value?: string | null;
  } | null;
  reference?: string | null;
  display?: string | null;
};

// Normalization
export function normalizeReferenceValue(value?: string | null): string {
  return (value ?? "").trim();
}

// Identifier lookup
export function getOfficialIdentifierValue(
  identifiers?: FhirIdentifier[] | null,
  preferredSystem?: string
): string {
  if (!identifiers?.length) {
    return "";
  }

  if (preferredSystem) {
    const preferredValue = identifiers.find(
      (identifier) =>
        identifier.use === "official" && identifier.system === preferredSystem
    )?.value;

    if (preferredValue) {
      return normalizeReferenceValue(preferredValue);
    }
  }

  const officialValue = identifiers.find(
    (identifier) => identifier.use === "official"
  )?.value;

  if (officialValue) {
    return normalizeReferenceValue(officialValue);
  }

  return normalizeReferenceValue(identifiers[0]?.value);
}

// Reference resolution
export function getReferenceValue(reference?: FhirReference | null): string {
  return (
    normalizeReferenceValue(reference?.identifier?.value) ||
    normalizeReferenceValue(reference?.reference?.split("/").pop()) ||
    normalizeReferenceValue(reference?.display)
  );
}

export function referenceMatchesValue(
  reference?: FhirReference | null,
  value?: string | null
): boolean {
  const expectedValue = normalizeReferenceValue(value);

  if (!expectedValue) {
    return false;
  }

  return (
    normalizeReferenceValue(reference?.identifier?.value) === expectedValue ||
    normalizeReferenceValue(reference?.reference?.split("/").pop()) ===
      expectedValue ||
    normalizeReferenceValue(reference?.display) === expectedValue
  );
}
